module.exports = __webpack_public_path__ + "static/media/apple-touch-icon.272d6ad4.png";